var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,255.98958,255.98958",
    width: "40px",
    height: "40px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ac7953",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(16,16)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.77344,1c-2.07812,0 -3.77344,1.69531 -3.77344,3.77344v5.45703c0,2.07422 1.69531,3.76953 3.77344,3.76953h5.45703c2.07422,0 3.76953,-1.69531 3.76953,-3.77344v-5.45313c0,-2.07812 -1.69531,-3.77344 -3.77344,-3.77344zM4.77344,2h5.45313c1.53906,0 2.77344,1.23438 2.77344,2.77344v5.45313c0,1.53906 -1.23437,2.77344 -2.76953,2.77344h-5.45703c-1.53906,0 -2.77344,-1.23437 -2.77344,-2.76953v-5.45703c0,-1.53906 1.23438,-2.77344 2.77344,-2.77344zM11.5,3c-0.27734,0 -0.5,0.22266 -0.5,0.5c0,0.27734 0.22266,0.5 0.5,0.5c0.27734,0 0.5,-0.22266 0.5,-0.5c0,-0.27734 -0.22266,-0.5 -0.5,-0.5zM7.5,4c-1.92578,0 -3.5,1.57422 -3.5,3.5c0,1.92578 1.57422,3.5 3.5,3.5c1.92578,0 3.5,-1.57422 3.5,-3.5c0,-1.92578 -1.57422,-3.5 -3.5,-3.5zM7.5,5c1.38672,0 2.5,1.11328 2.5,2.5c0,1.38672 -1.11328,2.5 -2.5,2.5c-1.38672,0 -2.5,-1.11328 -2.5,-2.5c0,-1.38672 1.11328,-2.5 2.5,-2.5z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.075165763c88e4a008b63cc10c33de5d.svg";
export { ForwardRef as ReactComponent };